<template>
  <div :id="id" class="content" :style="`height: ${curHeight}`">
    <div class="content-box">
      <div class="box" @mouseleave="mouseLeave">
        <div class="box-item">
          <img src="../../../assets/images/icon_identification_mail_handle.png">
          <p class="p-style">{{ resource["RESD8294754F768735"] }}</p>
          <p class="p ffcs-1">
            <span v-for="item in sortMailInfo" :key="item.moduleCode" style="margin: 0 5px;"
              @click="navMailDetailBySelf(resource['RESD8294754F768735'], item)" @mouseenter="mouseOver(item, '790px')">{{
                item.moduleName
              }}</span>
          </p>
        </div>
        <!-- 邮寄材料认证 -->
        <div v-for="item in sortMailInfo" :key="item.moduleCode">
          <div v-if="mouseModuleCode === item.moduleCode">
            <div class="hover-content hover-mail" v-bind:style="{ left: 0 + 'px' }">
              <div v-html="moduleSortMailMap[item.contentCode]" class="hover-box hover-box-left design-html"
                v-bind:style="{ '--beforeLeft': 143 + 'px', '--afterLeft': 142 + 'px' }">
              </div>

              <div class="more" @click="navMailDetailBySelf(resource['RESD8294754F768735'], item)">
                <!-- <div class="b-shadow"></div> -->
                显示更多
                <a-icon type="down" style="color: #cab484" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box" @mouseleave="mouseLeave">
        <div class="box-item">
          <img src="../../../assets/images/icon_identification_window_handle.png">
          <p class="p-style">{{ resource["RES0C8236BFE929586"] }}</p>
          <p class="p ffcs-2">
            <span v-for="item in sortCounterInfo" :key="item.moduleCode" style="margin: 0 5px;" @click="navCounterDetailBySelf(resource['RES0C8236BFE929586'], item)
              " @mouseenter="mouseOver(item, '790px')">{{ item.moduleName }}</span>
          </p>
        </div>
        <div v-for="item in sortCounterInfo" :key="item.moduleCode">
          <div v-if="mouseModuleCode === item.moduleCode">
            <div class="hover-content hover-window" v-bind:style="{ left: -291 + 'px' }">
              <div v-html="moduleSortCounterMap[item.contentCode]" class="hover-box design-html"
                v-bind:style="{ '--beforeLeft': 383 + 'px', '--afterLeft': 382 + 'px' }">
              </div>
              <div class="more" @click="navCounterDetailBySelf(resource['RES0C8236BFE929586'], item)">
                显示更多
                <a-icon type="down" style="color: #cab484" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box" @mouseleave="mouseLeave">
        <div class="box-item">
          <img src="../../../assets/images/icon_identification_onestop_handle.png">
          <p class="p-style">{{ resource["RES493B47E1358D59C"] }}</p>
          <p class="p ffcs-3" @mouseenter="mouseOver(moduleSortOneStop)"
            @click="pushRouter(`/selfComponents?name=公证认证“一站式”服务&linkname=领事认证/一站式办理/公证认证“一站式”服务/详情&type=3`)">
            公证认证“一站式”服务</p>
        </div>
        <div class="hover-content" v-if="mouseModuleItem === moduleSortOneStop"
          v-bind:style="{ left: -583 + 'px', width: 1140 + 'px' }">
          <div class="hover-box one-stop-service"
            v-bind:style="{ '--beforeLeft': 713 + 'px', '--afterLeft': 712 + 'px' }">
            <div style="font-size: 16px;">
              <p style="font-size: 20px; font-weight: bold;">业务简介</p>
              <p style="text-indent: 2em;">公证认证“一站式”服务是指我省公民和企业可在全省以下75家公证处办理公证书的同时，一并申请代办领事认证服务。</p>
              <p style="font-size: 20px; font-weight: bold;">“一站式”服务公证处</p>
            </div>
            <a-input-search class="a-input" placeholder="请输入公证处名称" size="large" v-model="params.officeName"
              @search="(e) => this.search(e)">
              <a-button slot="enterButton" type="primary">
                <a-icon type="search" />
                搜索
              </a-button>
            </a-input-search>
            <a-button @click="reset" style="height: 41px; margin-left: 15px;">重置</a-button>
            <div class="retrieval">
              <span>区域检索：</span>
              <div class="retrieval-content"
                :style="`border-bottom: ${item.fullPathCode === regionCodeFullPath ? '2px solid #cbb486;' : ''}`"
                v-for="(item) in newtagList" :key="item.regionName"
                @click="_getOneStopShop({ regionCodeFullPath: item.fullPathCode })">
                <span>{{ item.regionName }}</span>
              </div>
            </div>

            <div class="content-item">
              <div class="item-content" v-for="(item) in departmentList" :key="item.key">
                <div style="display: flex">
                  <img src="../../../assets/images/icon_identification_notarization_logo1.png"
                    style="height: 80px;width: 80px;margin-left: 42px;margin-top: 45px;vertical-align:middle;" />
                  <div style="vertical-align:middle;margin-left: 33px;margin-top: 42px">
                    <p class="item-title" style="margin-bottom: 20px">{{ item.officeName }}</p>
                    <div style="display: flex;">
                      <div class="item-left">
                        <p>联系电话:</p>
                        <p>机构地址:</p>
                      </div>
                      <div class="item-right">
                        <p>{{ item.officeMobile }}</p>
                        <p style="padding-bottom: 20px">{{ item.officeAddress }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="text-align: center;margin-top: 20px;height: 30px;">
              <a-pagination showQuickJumper showSizeChanger :pageSizeOptions="pageSizeOptions" :total="total"
                :showTotal="total => `总共 ${total} 条`" :itemRender="itemRender" :pageSize="6" @change="onChange">
                <template slot="buildOptionText" slot-scope="props">
                  <span v-if="props.value !== '50'">6条/页</span>
                </template>
              </a-pagination>
            </div>
            <div class="more" @click="pushRouter(`/selfComponents?name=认证费用&linkname=领事认证/一站式办理/公证认证“一站式”服务/详情&type=3`)">
              显示更多
              <a-icon type="down" style="color: #cab484" />
            </div>
          </div>
        </div>
      </div>
      <div class="box" @mouseleave="mouseLeave">
        <div class="box-item">
          <img src="../../../assets/images/icon_identification_remote_video_handle3.jpg">
          <p class="p-style">{{ resource["RES39064D73B28CDC5"] }}</p>
          <p class="p ffcs-4 rzcl">
            <span style="margin: 0 5px;" v-for="item in remoteLiveInfo" :key="item.moduleCode"
              @click="navDetailByContentCode(resource['RES39064D73B28CDC5'], item)"
              @mouseenter="mouseOver(item, '790px')">{{
                item.moduleName
              }}</span>
          </p>
        </div>
        <div v-for="item in remoteLiveInfo" :key="item.moduleCode">
          <div v-if="mouseModuleCode === item.moduleCode && item.moduleName === '办证须知'" class="hover-content hover-viedo"
            v-bind:style="{ left: -874 + 'px', width: 1140 + 'px' }">
            <div>
              <div v-html="moduleRemoteLiveMap[item.contentCode]" class="hover-box hover-box-left design-html"
                v-bind:style="{ '--beforeLeft': 143 + 'px', '--afterLeft': 142 + 'px' }">
              </div>

              <div class="more" @click="navMailDetailBySelf(resource['RES39064D73B28CDC5'], item)">
                <!-- <div class="b-shadow"></div> -->
                显示更多
                <a-icon type="down" style="color: #cab484" />
              </div>
            </div>
          </div>
          <div v-else-if="mouseModuleCode === item.moduleCode">
            <div class="hover-content hover-viedo" v-bind:style="{ left: -874 + 'px', width: 1140 + 'px' }">
              <div class="hover-box" v-bind:style="{ '--beforeLeft': 1005 + 'px', '--afterLeft': 1004 + 'px' }">

                <div style="font-size: 20px; padding-bottom: 20px; padding-left: 23px;font-weight: bold">{{
                  item.moduleName
                }}
                </div>
                <div class="hover-list" v-for="subItem in moduleRemoteLiveMap[item.moduleCode]"
                  :key="subItem.contentTitle"
                  @click="goDetail(subItem.contentCode, subItem.contentTitle, resource['RES39064D73B28CDC5'])">
                  <div>{{ subItem.contentTitle }}</div>
                  <span style="float: right">{{ String(subItem.createTime).split(" ")[0] }}</span>
                  <a-divider dashed />
                </div>
                <div class="more" @click="navDetailByContentCode(resource['RES39064D73B28CDC5'], item)">
                  显示更多
                  <a-icon type="down" style="color: #cab484" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pushContentAnnounceHtmlContent, pushModuleAnnounceHtmlContent } from "../../../util/navUtils";


const data = [
  {
    key: '1',
    country: '阿联酋',
    required: '只能双认证\n' + '所有委托类公证书（民事和商业）均收费4000元。',
    time: '30+',
  }
];
const searchArea = [
  { key: '1', name: '福建省' },
  { key: '2', name: '福州市', },
  { key: '3', name: '厦门市', },
  { key: '4', name: '莆田市', },
  { key: '5', name: '三明市', },
  { key: '6', name: '泉州市', },
  { key: '7', name: '漳州市', },
  { key: '8', name: '南平市', },
  { key: '9', name: '龙岩市', },
  { key: '10', name: '宁德市', },
  { key: '11', name: '平潭综合实验区', },
]
import {
  getContentCode,
  getStep,
  getMaterialList, // 邮寄认证材料
  getMaterCertCost, // 邮寄认证费用
  getWinMaterialList,
  getWinMaterCertCost,
  getCost, // 认证费用
  getOneStopShop, // 获取一站式
  getArea, // 获取中国区域
} from '@/api/consularCertification'

import { getModuleInfo, getModuleChild, getInfoByGet, getResource } from "@/api/moduleContent";


export default {
  name: 'hover-box',
  props: {
    id: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      curHeight: '280px',
      mouseSelection: '',
      data,
      height: '653.6px',
      searchArea,
      current: 2,
      departmentList: [],
      pageSizeOptions: ['6', '20', '30'],
      step1: '',
      step2: '',
      list1: [],
      list2: [],
      tagList: [],
      newtagList: [{ "regionCode": "350000", "regionName": "福建省", "fullPathCode": "350000", "level": 1 },
      { "regionCode": "350100", "regionName": "福州市", "fullPathCode": "350000.350100", "level": 2 },
      { "regionCode": "350200", "regionName": "厦门市", "fullPathCode": "350000.350200", "level": 2 },
      { "regionCode": "350600", "regionName": "漳州市", "fullPathCode": "350000.350600", "level": 2 },
      { "regionCode": "350500", "regionName": "泉州市", "fullPathCode": "350000.350500", "level": 2 },
      { "regionCode": "350400", "regionName": "三明市", "fullPathCode": "350000.350400", "level": 2 },
      { "regionCode": "350300", "regionName": "莆田市", "fullPathCode": "350000.350300", "level": 2 },
      { "regionCode": "350700", "regionName": "南平市", "fullPathCode": "350000.350700", "level": 2 },
      { "regionCode": "350800", "regionName": "龙岩市", "fullPathCode": "350000.350800", "level": 2 },
      { "regionCode": "350900", "regionName": "宁德市", "fullPathCode": "350000.350900", "level": 2 },
      { "regionCode": "350128", "regionName": "平潭综合实验区", "fullPathCode": "350000.350100.350128", "level": 3 }],
      total: 0,
      params: {},
      regionCodeFullPath: '350000',
      YCSPHtml: '',
      YCSPCode: '',
      WinMaterCertCost: '',
      WinMaterialList: '',
      MaterialList: '',
      MaterialCost: '',
      mouseModuleCode: '',
      mouseModuleItem: null,
      sortMailInfo: [],
      moduleSortMailMap: {},
      sortCounterInfo: [],
      moduleSortCounterMap: {},
      moduleSortOneStop: {
        moduleCode: '9999',
        moduleName: '一站式办理'
      },
      remoteLiveInfo: [],
      moduleRemoteLiveMap: {},
      resource: {}
    }
  },
  created() {
    this.getResource()
    this.mouseModuleCode = this._.get(this, '$route.query.m', '')
    this.curHeight = this._.get(this, '$route.query.h', '280px')

    this._getStep()
    this._getArea()
    this._getOneStopShop({ regionCodeFullPath: "350000" })
    this._getMaterial()

    this.getSortMailInfo();
    this.getSortCounterInfo();
    this.getRemoteLiveInfo();
  },
  methods: {
    getResource() {
      getResource("RES074C2AC49D371EC").then(res => {
        // debugger
        res.data.records && res.data.records.forEach(e => {
          // 邮寄办理
          if (e.resourceCode === "RESD8294754F768735") {
            this.resource["RESD8294754F768735"] = e.resourceName
          }
          // 窗口办理
          if (e.resourceCode === "RES0C8236BFE929586") {
            this.resource["RES0C8236BFE929586"] = e.resourceName
          }
          // 外办导航链接/一站式办理
          if (e.resourceCode === "RES493B47E1358D59C") {
            this.resource["RES493B47E1358D59C"] = e.resourceName
          }
          // 海外公证
          if (e.resourceCode === "RES39064D73B28CDC5") {
            this.resource["RES39064D73B28CDC5"] = e.resourceName
          }
          //
        })
      })
    },
    getSortMailInfo() {
      getModuleInfo('RES0C8236BFE929586').then((res) => {
        this.sortMailInfo = [];
        let sortMailChildArr = res.data.records.map((item) => {
          this.sortMailInfo.push({ ...item });
          return getModuleChild(item.moduleCode, 'contentAnnounce');
        })
        return Promise.all(sortMailChildArr)
      }).then((arr) => {
        const enterpriseChildInfoArr = arr.map(item => {
          const { contentCode, moduleCode } = item.data.records[0];
          this.sortMailInfo.forEach((val) => {
            if (val.moduleCode === moduleCode) {
              val['contentCode'] = contentCode;
            }
          })
          return getInfoByGet(contentCode);
        })
        return Promise.all(enterpriseChildInfoArr)
      }).then((datas) => {

        for (let index in datas) {
          const { contentHtml, contentCode, contentTitle } = datas[index].data;
          this.sortMailInfo.forEach((val) => {
            if (val.contentCode === contentCode) {
              val['contentTitle'] = contentTitle;
            }
          })
          this.$set(this.moduleSortMailMap, contentCode, contentHtml)
        }
      })
    },

    getSortCounterInfo() {
      getModuleInfo('RESD8294754F768735').then((res) => {
        this.sortCounterInfo = [];
        let sortMailChildArr = res.data.records.map((item) => {
          this.sortCounterInfo.push({ ...item });
          return getModuleChild(item.moduleCode, 'contentAnnounce');
        })
        return Promise.all(sortMailChildArr)
      }).then((arr) => {
        const enterpriseChildInfoArr = arr.map(item => {
          const { contentCode, moduleCode } = item.data.records[0];
          this.sortCounterInfo.forEach((val) => {
            if (val.moduleCode === moduleCode) {
              val['contentCode'] = contentCode;
            }
          })
          return getInfoByGet(contentCode);
        })
        return Promise.all(enterpriseChildInfoArr)
      }).then((datas) => {
        for (let index in datas) {
          const { contentHtml, contentCode, contentTitle } = datas[index].data;
          this.sortCounterInfo.forEach((val) => {
            if (val.contentCode === contentCode) {
              val['contentTitle'] = contentTitle;
            }
          })

          this.$set(this.moduleSortCounterMap, contentCode, contentHtml)
        }
      })
    },
    getRemoteLiveInfo() {
      getModuleInfo('RES39064D73B28CDC5').then((res) => {

        this.remoteLiveInfo = [];
        let sortMailChildArr = res.data.records.map((item) => {
          this.remoteLiveInfo.push({ ...item });
          console.log('this.remoteLiveInfo', this.remoteLiveInfo)
          return getModuleChild(item.moduleCode, 'contentAnnounce');
        })
        return Promise.all(sortMailChildArr)
      }).then((arr) => {

        const enterpriseChildInfoArr = arr.map(item => {
          const { moduleCode, contentCode } = item.data.records[0];
          this.remoteLiveInfo.forEach((val) => {
            if (val.moduleCode === moduleCode) {
              val['contentCode'] = contentCode;
            }
          })
          this.moduleRemoteLiveMap[moduleCode] = item.data.records;
          return getInfoByGet(contentCode);
        })
        return Promise.all(enterpriseChildInfoArr)

      }).then(datas => {
        for (let index in datas) {
          const { contentHtml, contentCode, contentTitle } = datas[index].data;
          this.remoteLiveInfo.forEach((val) => {
            if (val.contentCode === contentCode) {
              val['contentTitle'] = contentTitle;
            }
          })
          this.$set(this.moduleRemoteLiveMap, contentCode, contentHtml)
        }
        console.log('this.moduleRemoteLiveMap', this.moduleRemoteLiveMap)
      })
    },
    goDetail(contentCode, name, parentResourceName) {
      const type = "contentAnnounce";
      this.pushRouter(
        `/guide?contentCode=${contentCode}&type=${type}&linkname=领事认证/${parentResourceName}/${name}/详情`
      );
    },
    reset() {
      this.params = {}
      this._getOneStopShop()
    },
    _getArea() {
      getArea().then(res => {
        this.tagList = this._.get(res, 'data.records', [])
          .filter(item => {
            return (item.level === 1 || item.level === 2 || item.regionCode === '350128')
          }).sort((a, b) => a.level - b.level)
      })
    },
    _getOneStopShop(params) {
      this.params = { ...this.params, ...params }
      this.regionCodeFullPath = this.params.regionCodeFullPath
      getOneStopShop(this.params).then(res => {
        this.departmentList = this._.get(res, 'data.records', [])
        this.total = this._.get(res, 'data.total')
      })
    },
    search(officeName) {
      this.params = { officeName }
      this._getOneStopShop(this.params)
    },
    // 获取两个办理的下拉框内容
    _getMaterial() {
      getMaterialList().then(res => {
        this.MaterialList = res.data.contentHtml
      })
      getMaterCertCost().then(res => {
        this.MaterCertCost = res.data.contentHtml
      })
      getWinMaterialList().then(res => {
        this.WinMaterialList = res.data.contentHtml
      })
      getWinMaterCertCost().then(res => {
        this.WinMaterCertCost = res.data.contentHtml
      })
    },
    _getCost(name) {
      getCost(name).then(res => {
        this.list2 = this._.get(res, 'data', [])
        this.$nextTick(() => {
          const id = this.mouseSelection === 'mail-handling-fire' ? 'list3' : 'list4'
          const ele = document.getElementById(id)
          let offset = this._.get(ele, `offsetHeight`, '')
          this.curHeight = 1925.6 + offset + 'px'
          this.height = 1644.6 + offset + 'px'
        })
      })
    },
    // 获取步骤
    _getStep() {
      // 获取邮寄受理RES005D60C01B8AD9B
      getStep('RES005D60C01B8AD9B').then(res => {
        this.step1 = this._.get(res, 'data.contentHtml', '')
      })
      // 获取窗口步骤RESE6308ADD56E6DA9
      getStep('RESE6308ADD56E6DA9').then(res => {
        this.step2 = this._.get(res, 'data.contentHtml', '')
      })
    },
    // 移入
    mouseOver(moduleItem, height) {
      this.curHeight = height || '790px'
      this.height = '440px'
      this.mouseModuleCode = moduleItem.moduleCode;
      this.mouseModuleItem = moduleItem;
    },
    // 移出
    mouseLeave() {
      this.curHeight = '280px'
      this.mouseModuleCode = '';
      this.mouseModuleItem = null;
    },
    onChange(pageNumber) {
      this._getOneStopShop({ pageNo: pageNumber })
    },
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return <li class="ant-pagination-item"><a>上页</a></li>;
      } else if (type === 'next') {
        return <li class="ant-pagination-item"><a>下页</a></li>;
      }
      return originalElement;
    },
    navDetailByContentCode(parentName, moduleItem) {
      let linkname = `领事认证/${parentName}/${moduleItem.moduleName}`
      pushModuleAnnounceHtmlContent(this, moduleItem.moduleCode, moduleItem.moduleName, linkname);
    },

    navDetailByModuleCode(parentName, moduleItem) {
      let linkname = `领事认证/${parentName}/${moduleItem.moduleName}`
      pushModuleAnnounceHtmlContent(this, moduleItem.moduleCode, moduleItem.moduleName, linkname);
    },
    // 我的消息
    navMailDetailBySelf(parentName, moduleItem) {
      console.log(moduleItem,'模块id')
      debugger
      if (moduleItem.contentCode === "RES0D261CF3C2A2DE5") {//认证费用
        let linkname = `领事认证/${parentName}/${moduleItem.moduleName}`
        this.pushRouter(`/selfComponents?name=${moduleItem.moduleName}&linkname=${linkname}/详情&type=1`);
      } else if (moduleItem.contentCode === "RES4C8C5399ACE990C") {
        let linkname = `领事认证/${parentName}/${moduleItem.moduleName}`
        this.pushRouter(`/selfComponents?name=${moduleItem.moduleName}&linkname=${linkname}/详情&type=2`)
      } else if (moduleItem.contentCode === "RESE6308ADD56E6DA9") {
        let linkname = `领事认证/${parentName}/${moduleItem.moduleName}`
        pushContentAnnounceHtmlContent(this, moduleItem.contentCode, moduleItem.moduleName, linkname);
      } else if(moduleItem.contentCode === "RES378D4F0A1EE0AE2"){
        let linkname = `领事认证/${parentName}/${moduleItem.moduleName}`
        pushContentAnnounceHtmlContent(this, moduleItem.contentCode, moduleItem.moduleName, linkname);
      }else {
        this.navDetailByContentCode(parentName, moduleItem);
      }
    },
    // 详情页
    navCounterDetailBySelf(parentName, moduleItem) {
      if (moduleItem.contentCode === "RESF793CC044524518") {//认证费用
        let linkname = `领事认证/${parentName}/${moduleItem.moduleName}`
        this.pushRouter(`/selfComponents?name=${moduleItem.moduleName}&linkname=${linkname}/详情&type=1`);
      } else if (moduleItem.contentCode === "RES332DAF7A1473125") {
        let linkname = `领事认证/${parentName}/${moduleItem.moduleName}`
        this.pushRouter(`/selfComponents?name=${moduleItem.moduleName}&linkname=${linkname}/详情&type=2`)
      } else if (moduleItem.contentCode === "RES005D60C01B8AD9B") {
        let linkname = `领事认证/${parentName}/${moduleItem.moduleName}`
        pushContentAnnounceHtmlContent(this, moduleItem.contentCode, moduleItem.moduleName, linkname);
      } else {
        this.navDetailByContentCode(parentName, moduleItem);
      }
    }
  },
}
</script>

<style scoped lang='less'>
/deep/ .ant-btn:hover {
  color: #decba4;
  background-color: #fff;
  border-color: #decba4;
}

/deep/ .ant-btn:focus {
  color: #decba4;
  background-color: #fff;
  border-color: #decba4;
}

/deep/ .ant-table-tbody>tr>td {
  padding: 0;
}

/deep/ .ant-input:focus {
  outline: none;
  box-shadow: none !important;
}

.fire-box:not(:last-of-type) {
  border-bottom: 1px solid #e5e5e5;
}

.content {
  width: 100%;
  position: relative;
  margin-top: 40px;

  &-box {
    width: 1140px;
    position: relative;
    margin: auto;
    // position: absolute;
    // left: 50%;
    // transform: translateX(-50%);
    text-align: left;
    font-size: 0px;
  }
}

.box:not(:last-of-type) {
  margin-right: 27px;
}

.box:hover {
  border: 1px solid #decba4;
  box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
}

.box {
  width: 264px;
  min-height: 260px;
  display: inline-block;
  border: 1px solid #e5e5e5;
  box-shadow: 1px 2px 7px 1px rgba(0, 0, 0, 0.04);
  text-align: center;
  cursor: default;
  position: relative;

  .box-item {
    position: relative;
    top: 22px;
    width: 264px;
    height: 260px;

    img {
      width: 64px;
      height: 64px;
      margin-top: 39px;
    }

    p {
      margin: 0;
      padding: 0;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #000000;
      margin-top: 23px;
    }

    .p:hover {
      color: #cbb486;
      cursor: pointer;
    }

    .p {
      margin-top: 22px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #7f7f7f;

      span {
        color: #7f7f7f;
      }

      span:hover {
        color: #cbb486;
      }
    }
  }
}

/deep/.hover-content {
  width: 1140px;
  height: 530px;
  position: absolute;
  overflow: hidden;
  top: 281px;
  left: 0px;
  display: flex;
  justify-content: space-between;
  padding: 39px;
  border: 1px solid #decba4;
  box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
}

/deep/.hover-window {
  height: 520px;
}

/deep/.hover-viedo {
  height: 520px;
}

/deep/.hover-mail {
  height: 520px;
}

/deep/.hover-box {
  flex: 1;
  text-align: left;

  p {
    padding: 0;
    margin: 0;
    padding-bottom: 15px;
  }

  /* div:hover {
    color: #CBB486;
  } */

  &.one-stop-service {
    div:hover {
      color: black;
    }
  }

  div:hover .down-btn {
    display: inline-block;
  }

  .boxx {
    margin: 0;
    padding: 0;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3d4652;
    line-height: 68px;
    border-bottom: 1px solid #eee;
    padding-left: 15px;
    position: relative;
    white-space: nowrap;

    .down-btn {
      line-height: 36px;
      color: #cbb486;
    }

    img {
      line-height: 36px;
      margin-top: 0px;
    }
  }

  .boxx::before {
    content: "";
    display: inline-block;
    border-radius: 50%;
    width: 5px;
    height: 5px;
    background: rgba(203, 180, 134, 1);
    position: absolute;
    left: -1px;
    top: 31px;
  }

  .retrieval {
    width: 100%;
    margin-top: 20px;
    display: flex;

    span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #7f7f7f;
      line-height: 28px;
      vertical-align: middle;
    }

    .retrieval-content {
      display: inline-block;
      width: auto;
      padding: 0 15px;
      height: 32px;
      vertical-align: middle;
      text-align: center;

      span {
        color: #3a3a3a;
      }
    }

    .retrieval-content:hover {
      background: #cbb486;
      color: #ffffff;

      span {
        color: #ffffff;
      }
    }
  }
}

// .hover-box:first-of-type {
//   margin-right: 40px;
// }

.down-btn {
  display: inline-block;
  display: none;
  width: 100px;
  height: 40px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid #cbb486;
  vertical-align: middle;
  text-align: center;

  img {
    width: 16px;
    height: 16px;
  }
}

.more {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #cab484;
  position: absolute;
  display: block;
  height: 70px;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  background: white;
  width: 100%;
  line-height: 70px;
  text-align: center;
  // opacity: 0.8;
}

.b-shadow {
  height: 20px;
  opacity: 0.5;
  z-index: 99;
}

.hover-box::before {
  box-sizing: content-box;
  width: 0px;
  height: 0px;
  position: absolute;
  top: -16px;
  //left:143px;
  left: var(--beforeLeft);
  padding: 0;
  border-bottom: 8px solid #ffffff;
  border-top: 8px solid transparent;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  display: block;
  content: "";
  z-index: 12;
}

.design-html img {
  width: 100%;
}

.hover-box::after {
  box-sizing: content-box;
  width: 0px;
  height: 0px;
  position: absolute;
  top: -18px;
  //left:142px;
  left: var(--afterLeft);
  padding: 0;
  border-bottom: 9px solid #cbb486;
  border-top: 9px solid transparent;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  display: block;
  content: "";
  z-index: 10;
}

.hover-box.hover-box-left::before {
  // left: 955px;
}

.hover-box.hover-box-left::after {
  // left: 954px;
}



.hover-content {
  .hover-address {
    color: rgba(61, 70, 82, 1);
    font-size: 16px;
    padding-top: 15px;

    span {
      color: rgba(24, 144, 255, 1);
    }
  }
}

.a-input {
  width: 520px;

  /deep/ .ant-input-group-addon,
  /deep/ .ant-btn {
    width: 120px;
    height: 40px;
    background: #cbb486;
    border-radius: 0px 4px 4px 0px;
    border-color: #cbb486;
  }

  /deep/ .ant-input {
    width: 400px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #cbb486;
    border-radius: 4px 0px 0px 4px;
  }
}

.a-table-c {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #1d1d1f;
}
</style>
<style scoped lang='less'>
.content-item {
  margin: 2px 0 0 -15px;
  width: 1142px;

  .item-content {
    margin-top: 20px;
    margin-right: 15px;
    margin-left: 15px;
    width: 505px;
    min-height: 170px;
    height: auto;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    display: inline-block;

    .item-title {
      height: 18px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #3a3a3a;
      line-height: 28px;
    }

    .item-left {
      width: 61px;
      height: 44px;
      margin-right: 6px;
    }

    .item-right {
      width: 234px;
      height: 64px;
    }

    .item-left p,
    .item-right p {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #7f7f7f;
      display: inline-block;
      vertical-align: middle;
      margin-bottom: -10px;
    }
  }

  .item-content:hover {
    border: 1px solid #cdad7f;
    box-shadow: 0px 0px 20px 4px rgba(222, 203, 164, 0.32);
  }
}

/deep/ .ant-pagination-disabled,
.ant-pagination-disabled:hover,
.ant-pagination-disabled:focus {
  cursor: not-allowed;
  display: none;
}

/deep/ .ant-pagination-item-active a {
  color: #ffffff;
  background-color: #cbb486;
}

/deep/ .ant-pagination-item-active {
  border-color: #cbb486;
}

/deep/ .ant-pagination a:hover {
  color: #cbb486;
}

/deep/ .ant-pagination li:hover {
  border-color: #cbb486;
}

.img-list {
  display: block;
  margin-bottom: 20px;
  padding: 0;

  img {
    width: 800px;
    height: auto;
    display: block;
    margin: 0 auto;
    padding: 0;
  }
}

/deep/ .ant-table-placeholder {
  height: 100px;
}

/deep/ .ant-empty-normal {
  margin: 12px 0;
}

.type-af::after {
  content: "";
  display: inline-block;
  width: 1px;
  height: 55px;
  background: #e5e5e5;
  position: absolute;
  top: 1px;
  right: 163px;
}


.hover-list {
  width: 98%;
  font-size: 16px;
  margin-bottom: 25px;
  padding-left: 20px;
  height: 33px;

  &>div:nth-of-type(1) {
    width: 70%;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
  }

  &:hover {
    color: #cbb486;
  }
}

.hover-list::before {
  content: "";
  display: inline-block;
  width: 6px;
  height: 6px;
  background: #cbb486;
  border-radius: 50%;
  margin-left: 15px;
  transform: translate(-10px, -10px);
}

/deep/ .ant-divider {
  margin: 10px 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/home/consularCertification/siderContent-01.vue